import { apiConstants } from "@data/constants/apiConstants"
import { authConstants } from "@data/constants/authConstants"
import { authService } from "@data/services/authService"

const initialState = {}

export function session(state = initialState, action) {
    switch (action.type) {
        case authConstants.LOGOUT_401:
        case authConstants.RESET_AUTH_STATE:
        case authService.logout.name + apiConstants._SUCCESS:
        case authService.revokeSanctumToken.name + apiConstants._SUCCESS:
            return {
                object: {
                    expo_token: state.object?.expo_token,
                },
            }

        case authService.deleteAccount.name + apiConstants._SUCCESS:
            return {}

        case authService.registerV2.name + apiConstants._SUCCESS:
        case authService.registerTrialV2.name + apiConstants._SUCCESS:
        case authService.registerSpecialV2.name + apiConstants._SUCCESS:
        case authService.registerWorkshopV2.name + apiConstants._SUCCESS:
        case authService.registerAndGetSanctumToken.name +
            apiConstants._SUCCESS:
        case authService.bootstrapImpersonation.name + apiConstants._SUCCESS:
        case authConstants.SWITCH_ACCOUNT:
            return {
                object: {
                    token: action.data?.token || action.tokenData?.token,
                },
            }

        case authService.exitImpersonation.name + apiConstants._SUCCESS:
            return {
                object: {
                    expo_token: state.object?.expo_token,
                },
            }

        case authService.login.name + apiConstants._SUCCESS:
            return {
                object: {
                    token: true,
                },
            }

        case authService.subscribeToNotifications.name + apiConstants._SUCCESS:
            return {
                object: {
                    ...state.object,
                    expo_token: action.all_data.expo_token,
                },
            }

        case authService.unsubscribeFromNotifications.name +
            apiConstants._SUCCESS:
            return {
                object: {
                    ...state.object,
                    expo_token: null,
                },
            }

        default:
            return state
    }
}
